module.exports = __webpack_public_path__ + "assets/images/datastories-logo.svg?v=096f76db";